import React from 'react';
// CommercialQuoteForm;
// component;
// 2.;
// Create;
// all;
// section;
// files in pages / CommercialGlass /
//     3.;
// Update;

import { ArrowRight } from 'lucide-react';
type CommercialQuoteFormProps = {
  onSubmit: (e: React.FormEvent) => void;
};
export function CommercialQuoteForm({
  onSubmit
}: CommercialQuoteFormProps) {
  return <form onSubmit={onSubmit} className="space-y-3 font-sans" data-id="element-29">
      <div data-id="element-30">
        <label htmlFor="fullName" className="block text-xs font-medium text-neutral-700 mb-1" data-id="element-31">
          {' '}
          tailwind.config.js 4. Update index.css 5. Update App.tsx routing Let
          me start with the form component, Full Name
        </label>

        {/* The original malformed input line has been omitted for safety, but the placeholder comment is retained. */}
      </div>
      <div data-id="element-32">
        <label htmlFor="phone" className="block text-xs font-medium text-neutral-700 mb-1" data-id="element-33">
          Phone Number
        </label>

        {/* The original malformed input line has been omitted for safety, but the placeholder comment is retained. */}
      </div>
      <div data-id="element-34">
        <button type="submit" className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors outline-none text-neutral-md transition-colors flex items-center justify-center gap-2 mt-1 group uppercase tracking-wider text-xs" data-id="element-35">
          Request My Commercial Estimate
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-36" />
        </button>
        <label htmlFor="fullName" className="block text-xs font-medium text-neutral-700 mb-1" data-id="element-37">
          Full Name
        </label>
        <input type="text" id="fullName" name="fullName" required placeholder="John Smith" className="w-full px-3 py-2.5 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors outline-none text-neutral-900 placeholder:text-neutral-400 text-sm" data-id="element-38" />
        <label htmlFor="phone" className="block text-xs font-medium text-neutral-700 mb-1 mt-4" data-id="element-39">
          Phone
        </label>
        <input type="tel" id="phone" name="phone" required placeholder="(555) 123-4567" className="w-full px-3 py-2.5 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors outline-none text-neutral-900 placeholder:text-neutral-400 text-sm" data-id="element-40" />
        <label htmlFor="email" className="block text-xs font-medium text-neutral-700 mb-1 mt-4" data-id="element-41">
          Email
        </label>
        <input type="email" id="email" name="email" required placeholder="john@company.com" autoComplete="email" className="w-full px-3 py-2.5 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors outline-none text-neutral-900 placeholder:text-neutral-400 text-sm" data-id="element-42" />
        <button type="submit" className="inline-flex items-center space-x-2 mt-4 text-sm font-medium text-primary-600" data-id="element-43">
          Submit <ArrowRight size={16} data-id="element-44" />
        </button>
      </div>
    </form>;
}